import React from 'react';

function ComponentRenderer({ component, previewMode = false }) {
  const { type, props, style } = component;

  const renderComponent = () => {
    switch (type) {
      case 'text':
        const Tag = props.tag || 'p';
        return (
          <Tag style={style} className={props.className}>
            {props.content || 'Your text here...'}
          </Tag>
        );

      case 'image':
        return (
          <img
            src={props.src || '/placeholder.jpg'}
            alt={props.alt || 'Image'}
            style={{
              width: props.width || '100%',
              height: props.height || 'auto',
              ...style
            }}
            className={props.className}
          />
        );

      case 'button':
        return (
          <a
            href={props.link || '#'}
            style={style}
            className={`btn ${getButtonClass(props.variant)} ${props.className || ''}`}
            onClick={previewMode ? undefined : (e) => e.preventDefault()}
          >
            {props.text || 'Click Me'}
          </a>
        );

      case 'banner':
        return (
          <div
            style={{
              backgroundImage: props.backgroundImage ? `url(${props.backgroundImage})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              minHeight: '400px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              color: 'white',
              ...style
            }}
            className={props.className}
          >
            <div className="banner-content">
              {props.title && (
                <h1 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '1rem' }}>
                  {props.title}
                </h1>
              )}
              {props.subtitle && (
                <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
                  {props.subtitle}
                </p>
              )}
              {props.buttonText && (
                <a
                  href={props.buttonLink || '#'}
                  className="btn btn-primary btn-lg"
                  onClick={previewMode ? undefined : (e) => e.preventDefault()}
                >
                  {props.buttonText}
                </a>
              )}
            </div>
          </div>
        );

      case 'menu_section':
        return (
          <div style={style} className={props.className}>
            <div className="container">
              {props.title && (
                <h2 className="text-center mb-4">{props.title}</h2>
              )}
              <div className="row">
                {(props.categories || ['Breakfast', 'Lunch', 'Dinner']).map((category, index) => (
                  <div key={index} className="col-md-4 mb-3">
                    <div className="card">
                      <div className="card-body text-center">
                        <h5 className="card-title">{category}</h5>
                        <p className="card-text">Delicious {category.toLowerCase()} options</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case 'contact_form':
        return (
          <div style={style} className={props.className}>
            {props.title && <h3 className="mb-3">{props.title}</h3>}
            <form>
              {(props.fields || ['name', 'email', 'message']).map((field, index) => (
                <div key={index} className="mb-3">
                  <label className="form-label text-capitalize">{field}</label>
                  {field === 'message' ? (
                    <textarea 
                      className="form-control" 
                      rows={3}
                      placeholder={`Enter your ${field}`}
                    />
                  ) : (
                    <input 
                      type={field === 'email' ? 'email' : 'text'} 
                      className="form-control"
                      placeholder={`Enter your ${field}`}
                    />
                  )}
                </div>
              ))}
              <button 
                type="submit" 
                className="btn btn-primary"
                onClick={previewMode ? undefined : (e) => e.preventDefault()}
              >
                {props.submitText || 'Send Message'}
              </button>
            </form>
          </div>
        );

      case 'two_column':
        return (
          <div 
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '2rem',
              ...style
            }}
            className={props.className}
          >
            <div className="column-content">
              {props.leftContent || 'Left column content'}
            </div>
            <div className="column-content">
              {props.rightContent || 'Right column content'}
            </div>
          </div>
        );

      case 'three_column':
        return (
          <div 
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              gap: '1.5rem',
              ...style
            }}
            className={props.className}
          >
            <div className="column-content">
              {props.leftContent || 'Left column'}
            </div>
            <div className="column-content">
              {props.centerContent || 'Center column'}
            </div>
            <div className="column-content">
              {props.rightContent || 'Right column'}
            </div>
          </div>
        );

      default:
        return (
          <div 
            style={{
              padding: '2rem',
              backgroundColor: '#f8f9fa',
              border: '2px dashed #ddd',
              textAlign: 'center',
              color: '#666',
              ...style
            }}
            className={props.className}
          >
            <i className="fas fa-question-circle fa-2x mb-2"></i>
            <p>Unknown component type: {type}</p>
          </div>
        );
    }
  };

  return (
    <div className="component-renderer">
      {renderComponent()}
    </div>
  );
}

function getButtonClass(variant) {
  const classes = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    success: 'btn-success',
    danger: 'btn-danger',
    warning: 'btn-warning',
    info: 'btn-info',
    outline: 'btn-outline-primary'
  };
  return classes[variant] || 'btn-primary';
}

export default ComponentRenderer;